import React from 'react';

const Error401 = () => {
  return (
    <div className="container notFound" style={{ textAlign: 'center' }}>
      <h1>401 Error</h1>
      <p>You are not authorized to see this page</p>
    </div>
  );
};

export default Error401;